module.exports = __webpack_public_path__ + "img/google_drive.03e9ddd3.png";